export function sleep(ms) {
	return new Promise(resolve => setTimeout(resolve, ms));
}

export async function waitForFrame() {
	await new Promise(resolve => {
		requestAnimationFrame(resolve)
	})
}